import { BaseE11ExternalLinkConfigProvider } from '@engineering11/ui-lib/e11-external-link'

export class E11ExternalLinkConfigProvider extends BaseE11ExternalLinkConfigProvider {
  get config() {
    return {
      siteTitle: 'Cnect',
    }
  }
}
